import { Dialog } from 'common/components/Dialog';
import { DialogAlertData, removeAppMessage } from 'modules/alerts/state';
import { useAppDispatch } from 'store';

export type AlertDialogProps = DialogAlertData;

export const AlertDialogContainer = ({
  id,
  options: { actionToDispatchOnClose, actionToDispatchOnConfirm, ...options },
}: AlertDialogProps) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(removeAppMessage(id));
    if (actionToDispatchOnClose) {
      dispatch(actionToDispatchOnClose);
    }
  };

  const handleConfirm = () => {
    dispatch(removeAppMessage(id));
    if (actionToDispatchOnConfirm) {
      dispatch(actionToDispatchOnConfirm);
    }
  };

  return (
    <Dialog
      isOpen
      onClose={handleClose}
      onConfirm={handleConfirm}
      maxWidth="xs"
      showCancelButton={false}
      showCloseButton={false}
      role="alertdialog"
      confirmLabel="Close"
      {...options}
    />
  );
};
